import React from 'react';
import Card from '../../../../ui/card/card';
import ComponentLoader from '../../../../ui/loaders/componentLoader/componentLoader';

import './cardsGrid.scss';

interface ICardSGrid {
  pins?: any;
  loading?: any;
}

interface IItem {
  documentId?: string;
  assignId?: string;
}

const CardsGrid: React.FC<ICardSGrid> = ({ pins, loading }) => {
  return (
    <section className={'cards-grid-wrapper'}>{loading ? <ComponentLoader /> : pins.map((item: IItem) => <Card key={item.assignId} item={item} />)}</section>
  );
};

export default CardsGrid;
